import {request, serviceUrl} from "@/utils/request";

//获取主机列表
export function gatewayList() {
    return request({
        url: serviceUrl.deviceService + '/device/gateway/list'
    })
}

//获取没有配置告警的主机列表
export function getUnSettingList() {
    return request({
        url: serviceUrl.deviceService + '/device/gateway/getUnSettingList'
    })
}

//主机信息修改
export function updateGatewayInfo(params) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/device/gateway/updateGatewayInfo',
        data: params
    })
}

//根据sn码清空设备
export function clearDeviceBySnCode(snCode) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/device/gateway/clear-device',
        params: {snCode}
    })
}

//根据sn码同步设备
export function synchronizationTime(machineId) {
    const date = new Date();
    const currentDateTime = date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0') + ' ' +
        String(date.getHours()).padStart(2, '0') + ':' +
        String(date.getMinutes()).padStart(2, '0') + ':' +
        String(date.getSeconds()).padStart(2, '0');
    return request({
        url: serviceUrl.deviceService + '/device/gateway/synchronizationTime',
        params: {machineId: machineId, dateTime: currentDateTime}
    })
}

//根据sn码批量同步设备
export function synchronizationSystemTimeBatch(machineIdList) {
    const date = new Date();
    const currentDateTime = date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0') + ' ' +
        String(date.getHours()).padStart(2, '0') + ':' +
        String(date.getMinutes()).padStart(2, '0') + ':' +
        String(date.getSeconds()).padStart(2, '0');
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/device/gateway/synchronizationSystemTimeBatch',
        data: {machineIdList: machineIdList, dateTime: currentDateTime}
    })
}
